// Filter actions

module.exports = (function() {
    var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
    var $filters = $('.grantees-filters, .fellows-filters');

    var filter = function(event) {
        $(event.target).closest('form').submit();
    };

    var init = function() {

        if ($filters.length) {
            $filters.find('select').on('change', filter );
        }
    };

    return {
        init: init
    };
})();
